import { useLegalRegion } from './use-legal-region';
import { getLegalLinks, getLegalEntity } from '../app-ui-config';

function useLegalInfo() {
    const legalRegion = useLegalRegion();

    return {
        legalLinks: getLegalLinks(legalRegion),
        legalEntity: getLegalEntity(legalRegion)
    };
}

export {
    useLegalInfo
};
